import { memo, useCallback } from 'react';

import { IReportItem } from 'APIPackage/MainModule/interfaces/IReportItem';

import styles from './ReportItem.module.scss';

interface IReportItemProps {
  item: IReportItem;
  onItemClick: (type: IReportItem['type']) => void;
}

export const ReportItem = memo(({ item, onItemClick }: IReportItemProps) => {
  const onClick = useCallback(() => onItemClick(item.type), [item.type, onItemClick]);
  const listItemAttributes = {
    ...(item.isActive && { 'data-active': true }),
  };

  return (
    <div className={styles.ListItem} key={item.type} onClick={onClick} {...listItemAttributes}>
      {item.name}
    </div>
  );
});
